import { T } from '../strings'
import type { Theme } from '../theme'
import ScopePicker from '../components/ScopePicker'
import { MAX_FACTOR, type GameState, type Scope } from '../game/types'
import { tablePct, scopePct } from '../../shared/progress'
import { STICKER_TOTAL, level, masteredPct, stickerStrip, stickers } from '../game/selectors'

interface Props {
  state: GameState
  theme: Theme
  onPlay: () => void
  onScope: (scope: Scope) => void
}

/** «таблица на 7» / «таблица до 6» / «вся таблица» — подпись под кольцом. */
function zoneLabel(scope: Scope): string {
  if (scope.kind === 'single') return T.zoneSingle(scope.n)
  if (scope.kind === 'upto') return T.zoneUpto(scope.n)
  return T.zoneAll
}

export default function Home({ state, theme, onPlay, onScope }: Props) {
  const scope = state.settings.scope
  const pct = scopePct(state.progress, scope)
  const { list, unlocked } = stickers(state, theme)
  const strip = stickerStrip(list, unlocked)
  const streak = state.progress.streak
  const narrow = scope.kind === 'single' || (scope.kind === 'upto' && scope.n < MAX_FACTOR)

  const pctByNumber: Record<number, number> = {}
  for (let n = 2; n <= MAX_FACTOR; n++) pctByNumber[n] = tablePct(state.progress, n)

  return (
    <div className="home">
      <div className="home__center">
        <div
          className="ring"
          style={{ background: `conic-gradient(${theme.acc} ${pct}%, ${theme.line} 0)` }}
        >
          <div className="ring__hole">
            <div>
              <div className="ring__pct">{pct}%</div>
              <div className="label">{T.learned}</div>
            </div>
          </div>
        </div>

        <div className="home__meta">
          <div className="home__zone">{zoneLabel(scope)}</div>
          {/* Когда зона и есть вся таблица, вторая строка была бы тавтологией. */}
          {narrow && <div>{T.wholeTable(masteredPct(state))}</div>}
          <div>
            {T.level} {level(state)}
            {streak > 0 && ` · 🔥 ${T.streakDays(streak)}`}
          </div>
        </div>
      </div>

      <ScopePicker scope={scope} theme={theme} pctByNumber={pctByNumber} onChange={onScope} />

      <button type="button" className="btn-3d play-btn" onClick={onPlay}>
        {T.play}
      </button>

      <div className="strip">
        <div className="strip__icons">
          {strip.map((sticker, i) => (
            <div
              key={i}
              className="sticker"
              style={{ background: sticker.bg, opacity: sticker.locked ? 0.45 : 1 }}
              aria-hidden
            >
              {sticker.icon}
            </div>
          ))}
        </div>
        <div className="strip__count">{T.stickers(unlocked, STICKER_TOTAL)}</div>
      </div>
    </div>
  )
}
